import React from 'react';
import { motion } from 'framer-motion';
import LogoCarousel from './LogoCarousel';
const LogoSection = () => {
  return <section className="w-full bg-black py-6 px-4" data-id="element-138">
      <div className="max-w-7xl mx-auto" data-id="element-139">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7
      }} className="text-center" data-id="element-140">
          <h3 className="text-center text-sm sm:text-base text-white mb-4 leading-relaxed" data-id="element-141">
            Our team has been trusted by some of the world's most respected
            organizations…
          </h3>
          <LogoCarousel data-id="element-142" />
        </motion.div>
      </div>
    </section>;
};
export default LogoSection;